module.exports = __webpack_public_path__ + "img/156.e287b693.jpg";